import KaraokeModificationFormView2ModificationView from './KaraokeModificationFormView2ModificationView';
import KaraokeModificationFormView2CorrectionView from './KaraokeModificationFormView2CorrectionView';
import KaraokeModificationFormView2RemakeView from './KaraokeModificationFormView2RemakeView';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';

type KaraokeModificationFormView2FieldName = 'reason'|'correction'|'remake_url'|
  'modification_item1'|'modification_item2'|'modification_item3'|
  'modification_details1'|'modification_details2'|'modification_details3';

/**
 * 入力画面
 *
 * @param {object} props プロパティ
 * @returns コンポーネント
 */
export default function KaraokeModificationFormView2({
  getValue,
  setValue,
  getErrors,
  shouldRemakeForModification,
  onNext,
} : {
  getValue: (name: KaraokeModificationFormView2FieldName) => string,
  setValue: (name: KaraokeModificationFormView2FieldName, value: string) => void,
  getErrors: (name: KaraokeModificationFormView2FieldName) => FieldValidationErrorsType,
  shouldRemakeForModification: boolean,
  onNext: () => void,
}) {
  if (getValue('reason') === 'correction') {
    return (
      <KaraokeModificationFormView2CorrectionView
        getValue={getValue}
        setValue={setValue}
        getErrors={getErrors}
        onNext={onNext}
      />
    );
  }
  if (shouldRemakeForModification) {
    return (
      <KaraokeModificationFormView2RemakeView
        getValue={getValue}
        setValue={setValue}
        getErrors={getErrors}
        onNext={onNext}
      />
    );
  }
  return (
    <KaraokeModificationFormView2ModificationView
      getValue={getValue}
      setValue={setValue}
      getErrors={getErrors}
      onNext={onNext}
    />
  );
}
